export default {"src":"/_next/static/media/facebook.e0b396b9.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};